import { cn } from '@/app/lib';

interface DotsProps {
  count: number;
  currentIndex: number;
  onDotClick: (idx: number) => void;
  className?: string;
  buttonClassName?: string;
}

export function DotsIndicator({ count, currentIndex, onDotClick, className, buttonClassName }: DotsProps) {
  if (count <= 1) return null;

  return (
    <div className={cn('flex items-center gap-xs h-2.5', className)}>
      {Array.from({ length: count }).map((_, idx) => (
        <button
          key={idx}
          onClick={() => onDotClick(idx)}
          className={cn(
            'size-xs rounded-full cursor-pointer transition-colors duration-300',
            currentIndex === idx ? 'bg-primary' : 'bg-secondary-100 hover:bg-secondary-200',
            buttonClassName,
          )}
          tabIndex={0}
          aria-label={`Go to slide ${idx + 1}`}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              onDotClick(idx);
            }
          }}
        />
      ))}
    </div>
  );
}
